var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {}, [
    _vm.list.length || !_vm.listLoading
      ? _c("div", [
          _c(
            "div",
            { staticClass: "app-container" },
            [
              _c(
                "div",
                { staticClass: "button-container" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-add-config",
                      attrs: { type: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.handleCreate()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" Add New Region Config "),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-alert",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: {
                    title: "Navigation Step Splitting Configuration",
                    type: "info",
                    closable: false,
                  },
                },
                [
                  _vm._v(
                    ' Configure how the navigation system splits route steps based on angle changes. Each region can have different settings. The "DEFAULT" config is used as fallback when no region-specific config exists. '
                  ),
                ]
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.list,
                    "element-loading-text": "Loading...",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "ID", width: "60" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_vm._v(_vm._s(row.id))]
                          },
                        },
                      ],
                      null,
                      false,
                      3529122770
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Region", align: "center", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      row.region === "DEFAULT"
                                        ? "warning"
                                        : "primary",
                                  },
                                },
                                [_vm._v(" " + _vm._s(row.region) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      135908955
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Straight Directions",
                      align: "center",
                      width: "200",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return _vm._l(
                              row.straightClockDirections,
                              function (dir) {
                                return _c(
                                  "span",
                                  {
                                    key: dir,
                                    staticStyle: { margin: "0 2px" },
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      { attrs: { size: "mini", type: "info" } },
                                      [_vm._v(_vm._s(dir) + "h")]
                                    ),
                                  ],
                                  1
                                )
                              }
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      1480851126
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Min Distance (m)",
                      align: "center",
                      width: "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("strong", [
                                _vm._v(_vm._s(row.minDistanceThreshold) + "m"),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1251367619
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Same Street Check",
                      align: "center",
                      width: "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: row.enableSameStreetCheck
                                      ? "success"
                                      : "info",
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.enableSameStreetCheck
                                          ? "Enabled"
                                          : "Disabled"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2304516346
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Same St. Max Angle",
                      align: "center",
                      width: "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " + _vm._s(row.sameStreetMaxAngle) + "° "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4066690785
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Step Splitting",
                      align: "center",
                      width: "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: row.enableStepSplitting
                                      ? "success"
                                      : "danger",
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        row.enableStepSplitting ? "ON" : "OFF"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3227159668
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Status", align: "center", width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.isActive
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleStatus(row, false)
                                        },
                                      },
                                    },
                                    [_vm._v(" Active ")]
                                  )
                                : _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleStatus(row, true)
                                        },
                                      },
                                    },
                                    [_vm._v(" Inactive ")]
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1045370300
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Actions",
                      align: "center",
                      width: "180",
                      "class-name": "fixed-width",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpdate(row)
                                    },
                                  },
                                },
                                [_vm._v(" Edit ")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDeleteConfirmation(row)
                                    },
                                  },
                                },
                                [_vm._v(" Delete ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4248716430
                    ),
                  }),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title:
                      _vm.dialogStatus === "create"
                        ? "Create Navigation Config"
                        : "Edit Navigation Config",
                    visible: _vm.dialogFormVisible,
                    width: "650px",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogFormVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "dataForm",
                      staticStyle: { width: "560px", "margin-left": "20px" },
                      attrs: {
                        rules: _vm.rules,
                        model: _vm.tempData,
                        "label-position": "left",
                        "label-width": "200px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Region", prop: "region" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Select region",
                                disabled: _vm.dialogStatus === "update",
                                filterable: "",
                                "allow-create": "",
                              },
                              model: {
                                value: _vm.tempData.region,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tempData, "region", $$v)
                                },
                                expression: "tempData.region",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "DEFAULT (Fallback)",
                                  value: "DEFAULT",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "US (United States)",
                                  value: "US",
                                },
                              }),
                              _c("el-option", {
                                attrs: { label: "TR (Turkey)", value: "TR" },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "UK (United Kingdom)",
                                  value: "UK",
                                },
                              }),
                              _c("el-option", {
                                attrs: { label: "DE (Germany)", value: "DE" },
                              }),
                              _c("el-option", {
                                attrs: { label: "FR (France)", value: "FR" },
                              }),
                              _c("el-option", {
                                attrs: { label: "CA (Canada)", value: "CA" },
                              }),
                              _c("el-option", {
                                attrs: { label: "AU (Australia)", value: "AU" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                ' Region code. "DEFAULT" is used when no region-specific config is found. '
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Straight Clock Directions",
                            prop: "straightClockDirections",
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.tempData.straightClockDirections,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.tempData,
                                    "straightClockDirections",
                                    $$v
                                  )
                                },
                                expression: "tempData.straightClockDirections",
                              },
                            },
                            _vm._l(_vm.clockHours, function (hour) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: hour,
                                  staticStyle: { margin: "3px" },
                                  attrs: {
                                    label: hour,
                                    border: "",
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(hour) +
                                      " (" +
                                      _vm._s(_vm.getClockDescription(hour)) +
                                      ") "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                ' Clock directions considered as "straight" (no split). 12 = straight ahead, 3 = right turn, 9 = left turn. '
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Min Distance Threshold",
                            prop: "minDistanceThreshold",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: { min: 1, max: 100, step: 1 },
                            model: {
                              value: _vm.tempData.minDistanceThreshold,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tempData,
                                  "minDistanceThreshold",
                                  $$v
                                )
                              },
                              expression: "tempData.minDistanceThreshold",
                            },
                          }),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "8px" } },
                            [_vm._v("meters")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                " Minimum distance between points to consider splitting. Lower = more splits. "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Same Street Check",
                            prop: "enableSameStreetCheck",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "Enabled",
                              "inactive-text": "Disabled",
                            },
                            model: {
                              value: _vm.tempData.enableSameStreetCheck,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tempData,
                                  "enableSameStreetCheck",
                                  $$v
                                )
                              },
                              expression: "tempData.enableSameStreetCheck",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                " When enabled, prevents splitting within the same street if angle is below threshold. "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Same Street Max Angle",
                            prop: "sameStreetMaxAngle",
                          },
                        },
                        [
                          _c("el-input-number", {
                            attrs: { min: 0, max: 180, step: 5 },
                            model: {
                              value: _vm.tempData.sameStreetMaxAngle,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tempData,
                                  "sameStreetMaxAngle",
                                  $$v
                                )
                              },
                              expression: "tempData.sameStreetMaxAngle",
                            },
                          }),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "8px" } },
                            [_vm._v("degrees")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                " Max angle (degrees) that won't trigger a split when same street check is enabled. 90 = right angle. "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Step Splitting",
                            prop: "enableStepSplitting",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "ON",
                              "inactive-text": "OFF",
                            },
                            model: {
                              value: _vm.tempData.enableStepSplitting,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tempData,
                                  "enableStepSplitting",
                                  $$v
                                )
                              },
                              expression: "tempData.enableStepSplitting",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                color: "#909399",
                                "margin-top": "4px",
                              },
                            },
                            [
                              _vm._v(
                                " Master toggle. When OFF, Google steps are not split at all for this region. "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Active", prop: "isActive" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "Active",
                              "inactive-text": "Inactive",
                            },
                            model: {
                              value: _vm.tempData.isActive,
                              callback: function ($$v) {
                                _vm.$set(_vm.tempData, "isActive", $$v)
                              },
                              expression: "tempData.isActive",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogFormVisible = false
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.dialogStatus === "create"
                                ? _vm.createData()
                                : _vm.updateData()
                            },
                          },
                        },
                        [_vm._v(" Confirm ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "Delete Navigation Config",
                    visible: _vm.deleteConfirmationVisible,
                    width: "30%",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.deleteConfirmationVisible = $event
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "Are you sure you want to delete this navigation configuration? This action cannot be undone."
                    ),
                  ]),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.deleteConfirmationVisible = false
                            },
                          },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.deleteItem },
                        },
                        [_vm._v("Delete")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ])
      : _c("div", [
          _c(
            "div",
            {
              staticClass: "app-container",
              staticStyle: { "text-align": "center", padding: "50px" },
            },
            [
              _c("p", [
                _vm._v(
                  'No navigation configurations available. Click "Add New Region Config" to create one.'
                ),
              ]),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { type: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.handleCreate()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _vm._v(" Add New Region Config "),
                ]
              ),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }